var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTutorial03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.33337,
    y: 6.6665,
    width: 14.6667,
    height: 6.66667,
    fill: "#007AFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.66663,
    y: 14.6665,
    width: 18.6667,
    height: 6.66667,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0249 19.7097C22.1163 19.7097 21.3806 18.9721 21.3806 18.0641C21.3806 17.1562 22.1163 16.4185 23.0249 16.4185C23.9335 16.4185 24.6692 17.1562 24.6692 18.0641C24.6692 18.9721 23.9335 19.7097 23.0249 19.7097ZM9.41783 19.7097C8.51012 19.7097 7.77357 18.9721 7.77357 18.0641C7.77357 17.1562 8.51012 16.4185 9.41783 16.4185C10.3264 16.4185 11.063 17.1562 11.063 18.0641C11.063 18.9721 10.3264 19.7097 9.41783 19.7097ZM9.69535 11.9679L10.9091 8.49599C11.0664 8.05498 11.5834 7.69179 12.052 7.69179H20.352C20.824 7.69179 21.3427 8.05238 21.5009 8.49599L22.7423 11.9679C22.8979 12.4123 22.642 12.7729 22.1726 12.7729H10.2685C9.79909 12.7729 9.54061 12.4089 9.69535 11.9679ZM25.6668 11.7046L23.6897 6.32596C23.49 5.78032 22.8451 5.33325 22.2676 5.33325H13.1974H10.1759C9.59414 5.33325 8.95096 5.78032 8.75299 6.32596L8.4703 7.09643L6.76292 11.7331C6.76292 11.7331 4 14.4812 4 14.9309V21.6429C4 22.2283 4.47547 22.7022 5.05987 22.7022H6.20533V24.6643C6.20533 25.5619 6.92891 26.2856 7.81761 26.2856C8.70977 26.2856 9.42989 25.5619 9.42989 24.6643V22.7022H23.0094V24.6643C23.0094 25.5619 23.7338 26.2856 24.6268 26.2856C25.5173 26.2856 26.24 25.5619 26.24 24.6643V22.7022H27.3846C27.969 22.7022 28.4444 22.2283 28.4444 21.6429V14.9309C28.4444 14.5175 25.6668 11.7046 25.6668 11.7046Z",
    fill: "#B9DAFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTutorial03);
export default __webpack_public_path__ + "static/media/icon_tutorial_03.49134e552918e7b3177562381f906acd.svg";
export { ForwardRef as ReactComponent };